span {
  color: #333;
  background-color: #e7e6e6;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 12.5px;
  vertical-align: middle;
  position: relative;
  top: -1px;
}
